import UserManagementList from '../components/UserManagementList.vue';
import CreateUserAccount from '../components/CreateUserAccount.vue';
import UserDetail from '../components/UserDetail.vue';
import AccountTab from '../components/tabs/AccountTab.vue';
import AccessTab from '../components/tabs/AccessTab.vue';
import RbacTab from '../components/tabs/RbacTab.vue';

const detailBreadcrumb = (tabTitle) => [
  {
    path: '/home',
    title: 'Home'
  },
  {
    path: '/user-management/list',
    title: 'User Management'
  },
  {
    path: '/user-management',
    title: 'User Details',
    isDisplayId: true
  },
  {
    path: '',
    title: tabTitle
  }
];

export default [
  {
    path: '',
    redirect: 'list'
  },
  {
    path: 'list',
    component: UserManagementList,
    meta: {
      title: 'List of users',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'User Management'
        },
        {
          path: 'list',
          title: 'View Users'
        }
      ]
    }
  },
  {
    path: 'create-account',
    component: CreateUserAccount,
    meta: {
      title: 'Create User',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: 'list',
          title: 'User Management'
        },
        {
          path: '',
          title: 'Create User'
        }
      ]
    }
  },
  {
    path: ':id',
    component: UserDetail,
    meta: {
      title: 'User Details',
      role: ['User']
    },
    children: [
      {
        path: '',
        redirect: 'account'
      },
      {
        path: 'account',
        name: 'user-management-account',
        component: AccountTab,
        meta: {
          title: 'User Details - Account',
          role: ['User'],
          breadcrumb: detailBreadcrumb('Account')
        }
      },
      {
        path: 'access',
        name: 'user-management-access',
        component: AccessTab,
        meta: {
          title: 'User Details - Access',
          role: ['User'],
          breadcrumb: detailBreadcrumb('Access')
        }
      },
      {
        path: 'rbac',
        name: 'user-management-rbac',
        component: RbacTab,
        meta: {
          title: 'User Details - RBAC',
          role: ['User'],
          breadcrumb: detailBreadcrumb('RBAC')
        }
      }
    ]
  }
];
